import { Button } from 'react-bootstrap';

// Compare Button for the Data Element Cards
function CompareBtn ({de, setDrawerData, setShowCompareModal, setCompareDe, setCompareDeName}) {
    return (
        <Button variant="de-compare" className="bodyS position-absolute end-0" onClick={()=>{
            setDrawerData(de);
            setShowCompareModal(true);
            setCompareDe(de.deCode);
            setCompareDeName(de.deName);
        }}>
            Compare 
            <div className="compare-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M5.00553 7.77783H1.11108V8.88894H5.00553V10.5556L7.2222 8.33339L5.00553 6.11117V7.77783ZM8.32775 7.22228V5.55561H12.2222V4.4445H8.32775V2.77783L6.11108 5.00005L8.32775 7.22228Z" fill="#32363E"/>
                </svg>
            </div>
        </Button>
    );
}

export default CompareBtn;
